import railyApiService from "../raily-api.service";
import PassengerAddRequest from "./add/passenger-add-request";
import passengerAddRequestFactory from "./add/passenger-add-request.factory";
import PassengerAddResponse from "./add/passenger-add-response";
import passengerUpdateRequestFactory from "./update/passenger-update-request.factory";
import PassengerUpdateRequest, {
  PassengerUpdateRequestBody,
} from "./update/passenger-update.request";
import PassengerUpdateResponse from "./update/passenger-update.response";
import PassengerDataRequest from "./data/passenger-data.request";
import PassengerDataResponse from "./data/passenger-data.response";

const passengerApiService = () => {
  const add = async (
    request: PassengerAddRequest,
    abortSignal: AbortSignal,
  ): Promise<PassengerAddResponse> => {
    const url = `/passengers`;

    const body = passengerAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const update = (
    request: PassengerUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<PassengerUpdateResponse> => {
    const url = `/passengers/${request.passengerUuid}/edit-form`;

    const body: PassengerUpdateRequestBody =
      passengerUpdateRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const getData = (
    request: PassengerDataRequest,
    abortSignal: AbortSignal,
  ): Promise<PassengerDataResponse> => {
    const url = `/passengers/${request.passengerUuid}/edit-form`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  return {
    add,
    update,
    getData,
  };
};

export default passengerApiService;
